import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-200 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-100" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 影视作品封面`}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-0.5 text-xs font-bold text-background-50">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {item.type === "movie" ? "电影" : "剧集"}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.region}</span>
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}